import { ISeller } from '../../types/newbuilding/seller';

export const isLeadFactory = (agent: ISeller): boolean => agent.isLeadFactory;
